import { Product } from "./types/product";
import parse from "html-react-parser";
import { getUnixTime } from "date-fns";
import { FLYER_PROMOTIONS_SOURCE } from "./constant";

export const promotionMapping = async (data: Product | any) => {
  try {
    const currentDate = getUnixTime(new Date());
    const finalData: any = [];
    let activePromotionLength: any;

    if (data.length > 0) {
      for (const promotionData of data) {
        console.log(promotionData.objectID, "testdata");

        let activePromotions = promotionData?.promotions.filter((item: any) =>
          item.startDate <= currentDate &&
          item.endDate > currentDate &&
          item.promotionComplianceFlag === true
        );
        activePromotionLength = activePromotions.length;
        // if (activePromotionLength > 0) {
        //   const flyerPromo = activePromotions.find((item: any) => item.source === FLYER_PROMOTIONS_SOURCE);
        //   if (flyerPromo) activePromotions = [flyerPromo];
        //   activePromotionLength = activePromotions.length;
        // }

        if (activePromotionLength > 0) {
          const activePromotion = activePromotions?.[0] ?? {};
          const promotionReward = activePromotion.promotionReward?.[0] ?? {};
          const promotionCondition =
            activePromotion.promotionCondition?.[0] ?? {};
          const rewardLength = activePromotion.promotionReward?.length;
          const promotionLength = activePromotion.promotionCondition?.length;
          // Destructure the fields
          let {
            rewardType,
            membershipLevelText: memberType,
            value1Value20: rewardValueArray = [],
            rewardShortDesc: rewardDescription,
            rewardShortDescFrench: rewardDescriptionFr,
            rewardTrigger,
            applyTo: rewardApplyTo,
          } = promotionReward;

          let {
            value1Value20: promotionValueArray = [],
            conditionType,
            breakpointFlag,
          } = promotionCondition;

          let rewardValue = rewardValueArray?.[0]?.value_1;
          let promotionValue = promotionValueArray?.[0]?.value_1;

          // Promotion level info
          let {
            promotionDescription,
            promotionDescriptionFr,
            startDate: promotionStartDate,
            endDate: promotionEndDate,
            source: promotionSource,
          } = activePromotion;

          // Other values
          let salePrice: number;
          let memberPrice: number;
          let offerType: number;
          let newMemberType: string
          const rewardArticalID: string[] = [];
          let promotionFullDesc: any;

          // Final promoData object
          const promoData = {
            // Product data
            brand: promotionData?.brand,
            uom: promotionData?.uom,
            categories: promotionData?.categories,
            description: promotionData?.description,
            images: promotionData?.images,
            isVisible: promotionData?.isVisible,
            name: promotionData?.name,
            objectID: promotionData?.objectID,
            otherInformation: promotionData?.otherInformation,
            price: promotionData?.price,
            salePrice: promotionData?.salePrice,
            memberPrice: promotionData?.memberPrice,
            newMemberPrice: promotionData?.newMemberPrice,
            storeId: promotionData?.storeId,
            weight: promotionData?.weight,
            priceQuantity: promotionData?.priceQuantity,
            storageInstructions: promotionData?.storageInstructions,
            isOnSale: promotionData?.isOnSale,
            isMassOffers: promotionData?.isMassOffers,
            isFlyerProduct: promotionData?.isFlyerProduct,
            isActivePromotion: promotionData?.isActivePromotion,
            hierarchicalCategories: promotionData?.hierarchicalCategories,
            articleNumber: promotionData?.articleNumber,
            rewardArticalID,

            // Promo details
            conditionType,
            promotionDescription,
            promotionFullDesc,
            promotionDescriptionFr,
            rewardDescription,
            rewardDescriptionFr,
            rewardValue,
            rewardType,
            memberType,
            rewardTrigger,
            rewardApplyTo,
            promotionValue,
            promotionStartDate,
            promotionEndDate,
            promotionSource,
            breakpointFlag,
            cardType: memberType?.includes("Y") ? "Member" : "Scene+",
          };

          // calculation of price -- member and sale price
          const priceCalculation = (filteredPromo?: any) => {
            const isMember = filteredPromo ? filteredPromo?.promotionReward?.[0]?.membershipLevelText.includes("Y") : memberType?.includes("Y");
            const source = "CMA";
            const basePrice = parseFloat(promotionData?.price);
            const RV = filteredPromo ? parseFloat(filteredPromo?.promotionReward?.[0]?.value1Value20?.[0]?.value_1) : parseFloat(rewardValue);
            const wieght = parseFloat(promotionData?.weight);
            let calculatedPrice = 0;
            switch (rewardType) {
              case 1:
                calculatedPrice = promotionSource == source ? RV / 100 : RV;
                break;
              case 2:
                calculatedPrice =
                  promotionSource == source
                    ? (basePrice * RV) / 100
                    : basePrice * RV;
                break;
              case 3:
                calculatedPrice =
                  promotionSource == source
                    ? (RV / 100) * wieght
                    : RV * wieght;
                break;
              case 4:
              case 5:
                calculatedPrice = promotionSource == source ? RV / 100 : RV;
                return isMember
                  ? { memberPrice: calculatedPrice, salePrice }
                  : { salePrice: calculatedPrice, memberPrice: promoData?.memberPrice };
              // case 5:
              //   calculatedPrice =
              //     (RV * 1000) *
              //     parseFloat(promotionData?.weight);
              //   break;
              case 6:
                return isMember
                  ? { memberPrice: basePrice, salePrice }
                  : { salePrice: basePrice, memberPrice: promoData?.memberPrice };
              case 7:
                return { memberPrice: parseInt(rewardValue) };
              default:
                return {};
            }
            return isMember
              ? { memberPrice: basePrice - calculatedPrice, salePrice }
              : { salePrice: basePrice - calculatedPrice, memberPrice: promoData?.memberPrice };
          };
          // add promotion function
          const addPromotionData = (
            identifier: string,
            priceData: any,
            offerType: number,
            promotionDescription?: any
          ) => {
            promoData.memberType = promoData.memberType == '' ? "NNNNNNNNNNNNNNNN": promoData.memberType
            finalData.push({
              ...promoData, newMemberType,
              offerIdentifier: identifier,
              ...priceData,
              offerType,
              ...promotionDescription,
            });
            return finalData;
          };

          // Promotion description acc. to reward type  BMSM
          const promoDescBMSM = (
            breakpointFlag: any,
            conditionType: any,
            rewardTrigger: any
          ) => {

            let RV = promotionSource == 'CMA'? (parseFloat(rewardValue) / 100) :(parseFloat(rewardValue)) ;
            let RAT = rewardApplyTo ? rewardApplyTo : 1;
            switch (rewardType) {
              case 1:
                promotionDescription = parse(
                  `Buy <strong>$${RV}</strong> for <strong>${RAT}</strong> off`
                );
                break;
              case 2:
                promotionDescription = parse(
                  `Buy <strong>${RV}</strong> % for <strong>${RAT}</strong> off`
                );
                break;
              case 4:
                promotionDescription = parse(
                  `Buy <strong>$${RV}</strong> for <strong>${RAT}</strong>`
                );
                break;
            }
            return {
              promotionDescription: promotionDescription,
              promotionFullDesc: promotionDescription,
            };
          };

          // Promotion description acc. to reward type BuyXGetX- QTY
          const promoDescBXGX_QTY = (breakpointFlag: any, conditionType: any, rewardTrigger: any) => {
            if (breakpointFlag == undefined || breakpointFlag == "" || breakpointFlag == null) breakpointFlag = "N";
            if (conditionType == undefined || conditionType == "") conditionType = null;
            if (rewardTrigger == undefined || rewardTrigger == "") rewardTrigger = null;
            let RV = promotionSource == 'CMA'? (parseFloat(rewardValue) / 100) :(parseFloat(rewardValue)) ;
            let buyCndn = rewardTrigger ? rewardTrigger : parseInt(promotionValue);
            let buyDescription = rewardTrigger && rewardApplyTo ? (rewardTrigger - rewardApplyTo) : parseInt(promotionValue);
            let RAT = rewardApplyTo ? rewardApplyTo : parseInt(promotionValue);
            let RT = rewardTrigger ? rewardTrigger : parseInt(promotionValue);
            switch (rewardType) {
              case 1:
                if (breakpointFlag == "Y" && conditionType && rewardTrigger) {
                  promotionDescription = parse(
                    `Buy <strong>${buyCndn}</strong> for <strong>$${RV} off</strong>`
                  );
                } else if (
                  breakpointFlag == "Y" &&
                  conditionType &&
                  !rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Save <strong>$${RV.toFixed(2)}</strong> ea when you buy <strong>${RT}</strong> or more`
                  );
                } else if (
                  breakpointFlag == "Y" &&
                  !conditionType &&
                  !rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Save <strong>$${RV.toFixed(2)}</strong> ea when you buy <strong>${RT}</strong>`
                  );
                } else if (
                  breakpointFlag == "N" &&
                  !conditionType &&
                  rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Buy <strong>${buyDescription}</strong> and get <strong>${RAT}</strong> at <strong>$${RV.toFixed(2)}</strong> `
                  );
                } else {
                  promotionDescription = parse(
                    `Save <strong>$${RV.toFixed(2)}</strong> ea when you buy <strong>${RT}</strong>`
                  );
                }

                break;
              case 2:
                if (breakpointFlag == "Y" && conditionType && rewardTrigger) {
                  promotionDescription = parse(
                    `Buy <strong>${buyCndn}</strong> for <strong>${RV * 100}% off </strong>`
                  );
                } else if (
                  breakpointFlag == "Y" &&
                  conditionType &&
                  !rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Save <strong>${RV * 100}</strong>% ea when you buy <strong>${RT} </strong> or more`
                  );
                } else if (
                  breakpointFlag == "Y" &&
                  !conditionType &&
                  !rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Save <strong>${RV * 100}</strong>% ea when you buy <strong>${RT}</strong>`
                  );
                } else if (
                  breakpointFlag == "N" &&
                  !conditionType &&
                  rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Buy <strong>${buyDescription}</strong> and get <strong>${RAT}</strong> at <strong>${RV * 100}% off</strong> `
                  );
                } else {
                  promotionDescription = parse(
                    `Save <strong>${RV * 100}</strong>% ea when you buy <strong>${RT}</strong>`
                  );
                }
                break;
              case 4:
                if (breakpointFlag == "Y" && conditionType && rewardTrigger) {
                  promotionDescription = parse(
                    `Buy <strong>${buyDescription}</strong> and get <strong>${RAT}</strong> for <strong>$${RV.toFixed(2)}</strong>`
                  );
                } else if (
                  breakpointFlag == "Y" &&
                  conditionType &&
                  !rewardTrigger
                ) {
                  promotionDescription = parse(
                    `<strong>$${RV.toFixed(2)}</strong> ea when you buy <strong>${RT}</strong> or more`
                  );
                } else if (
                  breakpointFlag == "N" &&
                  !conditionType &&
                  rewardTrigger
                ) {
                  promotionDescription = parse(
                    `Buy <strong>${buyCndn}</strong> and get <strong>${RAT}</strong> at <strong>$${RV.toFixed(2)}</strong>`
                  );
                } else {
                  promotionDescription = parse(
                    `Buy <strong>${buyCndn}</strong> and get <strong>${RAT}</strong> at <strong>$${RV.toFixed(2)}</strong>`
                  );
                }
                break;
              case 6:
                promotionDescription = parse(
                  `Buy <strong>${buyDescription}</strong> and get <strong>${RAT}</strong> for free!</strong>`
                );
                break;
              case 7:
                promotionDescription = parse(
                  `Buy <strong>${buyCndn}</strong>  and get <strong>${RV * 100} points</strong>`
                );
                break;
            }
            return {
              promotionDescription: promotionDescription,
              promotionFullDesc: promotionDescription,
            };
          };

          // Promotion description acc. to reward type BuyXGetX - AMT
          const promoDescBXGX_AMT = (breakPoint: any) => {
            let RV = promotionSource == 'CMA'? (parseFloat(rewardValue) / 100) : (parseFloat(rewardValue)) ;
            let PV = promotionSource == 'CMA'? parseFloat(promotionValue) / 100 : parseFloat(promotionValue);
            let productName = promotionData?.name.slice(0, 15).concat("(...)");
            switch (rewardType) {
              case 1:
                promotionDescription = parse(
                  `Buy <strong>$${PV} </strong> of ${productName} and get <strong>$${RV} off</strong>`
                );
                promotionFullDesc = parse(
                  `Buy <strong>$${PV} </strong> of ${promotionData?.name} and get <strong>$${RV} off</strong>`
                );
                break;
              case 2:
                promotionDescription = parse(
                  `Buy <strong>$${PV}</strong> of ${productName} and get <strong>${RV * 100}% off</strong>`
                );
                promotionFullDesc = parse(
                  `Buy <strong>$${PV} </strong> of ${promotionData?.name} and get <strong>${RV * 100}% off</strong>`
                );
                break;
              case 7:
                promotionDescription = parse(
                  `Buy <strong>$${PV}</strong> of ${productName} and get <strong>${RV * 100} points</strong>`
                );
                promotionFullDesc = parse(
                  `Buy <strong>$${PV} </strong> of ${promotionData?.name} and get <strong>${RV * 100} points</strong>`
                );
                break;
            }
            return {
              promotionDescription: promotionDescription,
              promotionFullDesc: promotionFullDesc,
            };
          };

          // Promotion description acc. to reward type BuyXGetX - AMT
          const promoDescBXGX_KG = (breakPoint: any) => {
            let RV = promotionSource == 'CMA'? (parseFloat(rewardValue) / 100) : (parseFloat(rewardValue)) ;
            let PV = promotionValue < 1000 ? `${parseFloat(promotionValue)} g` : `${(parseFloat(promotionValue) / 1000).toFixed(2)} kg`;
            let productName = promotionData?.name.slice(0, 15).concat("(...)");
            switch (rewardType) {
              case 1:
                promotionDescription = parse(
                  `Buy <strong>${PV}</strong> of ${productName} and get <strong>$${RV.toFixed(2)} off</strong>`
                );
                promotionFullDesc = parse(
                  `Buy <strong>${PV}</strong> of ${promotionData?.name} and get <strong>$${RV.toFixed(2)} off</strong>`
                );
                break;
              case 2:
                promotionDescription = parse(
                  `Buy <strong>${PV}</strong> of ${productName} and get <strong>${RV * 100}% off</strong>`
                );
                promotionFullDesc = parse(
                  `Buy <strong>${PV}</strong> of ${promotionData?.name} and get <strong>${RV * 100}% off</strong>`
                );
                break;
              case 7:
                promotionDescription = parse(
                  `Buy <strong>${PV}</strong> of ${productName} and get <strong>${RV * 100} points</strong>`
                );
                promotionFullDesc = parse(
                  `Buy <strong>${PV}</strong> of ${promotionData?.name} and get <strong>${RV * 100} points</strong>`
                );
                break;
            }
            return {
              promotionDescription: promotionDescription,
              promotionFullDesc: promotionFullDesc,
            };
          };

          const promoDescMultiPromo = (breakPoint: any, newMemberPrice: number, conditionType: number, conditionValue: number) => {
            console.log("conditionType", conditionType, "conditionValue", conditionValue);
            let PV = conditionType == 2 ? parseInt((conditionValue/100).toString()):parseInt((conditionValue).toString()) ;
            let buyDescription = rewardTrigger ? rewardTrigger : (PV);
            buyDescription = buyDescription ? buyDescription : 1;
            let productName = promotionData?.name.slice(0, 15).concat("(...)");
            promotionDescription = parse(
              `Buy <strong>${conditionType == 2 ? "$" : ""}${ buyDescription}</strong> of ${productName} and get <strong>${newMemberPrice} points</strong>`
            );
            promotionFullDesc = parse(
              `Buy <strong>${conditionType == 2 ? "$" : ""}${ buyDescription} </strong> of ${promotionData?.name} and get <strong>${newMemberPrice} points</strong>`
            );
            return {
              promotionDescription: promotionDescription,
              promotionFullDesc: promotionFullDesc,
            };
          };
          const hasNoMinCondition = ((conditionType == undefined || conditionType == null || conditionType == "") &&
            (rewardTrigger == null || rewardTrigger == 1 || rewardTrigger == "")) ||
            (conditionType == 1 && promotionValue == 1 && (rewardTrigger == null || rewardTrigger == 1 || rewardTrigger == ""));
          if (activePromotionLength == 1) {
            // checking promotion ITEMS and rewards ITEMS are equal
            let promotionItems =
              activePromotions[0].promotionCondition?.[0]?.items;
            let rewardItems = activePromotions[0]?.promotionReward?.[0]?.items;
            //getting artical id from promotion reward
            rewardItems.forEach((elem: any) => {
              rewardArticalID.push(elem.articleNumber);
            });
            //single reward
            const conditionLength = activePromotions[0]?.promotionCondition.length;
            if (conditionLength == 1) {
              if (rewardLength == 1) {
                // no min spend condition
                console.log(">>>>> no min  condition");
                if (hasNoMinCondition) {
                  console.log("No Min Condition --", promotionData?.objectID, "reward_type--", rewardType);
                  const priceData = priceCalculation();
                  addPromotionData("No Min Condition", priceData, offerType = 1);
                } else {
                  // min spend condition
                  console.log(">>>>> min spend condition");
                  const promotionItemsCheck = promotionItems?.some(
                    (item: any) => item?.articleNumber == promoData?.articleNumber
                  );
                  const rewardItemsCheck = rewardItems?.some(
                    (item: any) => item?.articleNumber == promoData?.articleNumber
                  );
                  if (promotionItems == 0 || (promotionItemsCheck && rewardItemsCheck)) {
                    if (conditionType == 1 ||
                      ((conditionType == null || conditionType == "" || conditionType == undefined) && rewardTrigger > 1)) {
                      if (rewardTrigger == rewardApplyTo && rewardTrigger > 1) {
                        // success condition
                        console.log("YES Min Condition QTY 1--", promotionData?.objectID, "reward_type--", rewardType);
                        const priceData = priceCalculation();
                        promotionDescription = promoDescBMSM(
                          breakpointFlag,
                          conditionType,
                          rewardTrigger
                        );
                        addPromotionData("YES Min Condition QTY 1", priceData, offerType = 2, promotionDescription);
                      } else {
                        // no condition
                        console.log("No Min Condition QTY 1--", promotionData?.objectID, "reward_type--", rewardType);
                        const priceData = priceCalculation();
                        promotionDescription = promoDescBXGX_QTY(breakpointFlag, conditionType, rewardTrigger);
                        addPromotionData("No Min Condition QTY 1", priceData, offerType = 3, promotionDescription);
                      }
                      // }
                    } else if (conditionType == 2) {
                      console.log("YES Min Condition QTY 2--", promotionData?.objectID, "reward_type--", rewardType);
                      const priceData = priceCalculation();
                      promotionDescription = promoDescBXGX_AMT(breakpointFlag);
                      addPromotionData("YES Min Condition QTY 2", priceData, offerType = 4, promotionDescription);
                    } else if (conditionType == 3) {
                      console.log("YES Min Condition QTY 3--", promotionData?.objectID, "reward_type", rewardType);
                      const priceData = priceCalculation();
                      promotionDescription = promoDescBXGX_KG(breakpointFlag);
                      addPromotionData("YES Min Condition QTY 3", priceData, offerType = 5, promotionDescription);
                    }
                  }
                }
              } else if (rewardLength == 2) {
                if (promotionSource !== "CMA") {
                  for (const promoReward of activePromotions[0].promotionReward) {
                    if (promoReward?.items?.length > 0) {
                      rewardType = promoReward.rewardType;
                      memberType = promoReward?.membershipLevelText;
                      rewardValue = promoReward?.value1Value20?.[0]?.value_1;
                      promoData.rewardType = rewardType;
                      promoData.memberType = memberType;
                      promoData.rewardValue = rewardValue;
                      if (hasNoMinCondition) {
                        console.log("min from reward");
                        const priceData = priceCalculation();
                       // addPromotionData("No Min Condition", priceData);
                      }
                    }
                  }
                } else {
                  // multiple rewards
                  let priceData: any = {};
                  let res: any;
                  let hasRewardType7 = false;
                  let newRewardType;
                  let newRewardValue;
                  for (const promoReward of activePromotions[0].promotionReward) {
                    if (promoReward.rewardType == 7) {
                      hasRewardType7 = true;
                      rewardType = promoReward.rewardType;
                      memberType = promoReward?.membershipLevelText;
                      rewardValue = promoReward?.value1Value20?.[0]?.value_1;
                      promoData.rewardType = rewardType;
                      //promoData.memberType = memberType;
                      promoData.rewardValue = rewardValue;
                      res = priceCalculation();
                      priceData.memberPrice = res?.memberPrice;
                    } else if (promoReward.rewardType !== 7) {
                      rewardType = promoReward.rewardType;
                      newRewardType = promoReward.rewardType
                      memberType = "NNNNNNNNNNN";
                      rewardValue = promoReward?.value1Value20?.[0]?.value_1;
                      newRewardValue = promoReward?.value1Value20?.[0]?.value_1
                      promoData.rewardType = rewardType;
                      promoData.memberType = memberType;
                      promoData.rewardValue = rewardValue;
                      res = priceCalculation();
                      salePrice = res?.salePrice
                      priceData.salePrice = salePrice;
                    }
                  }
                  if (hasRewardType7) {
                    promoData.memberType = 'YYYYYYYYYYYYYYYY'
                    promoData.rewardType = newRewardType;
                    promoData.rewardValue = newRewardValue;
                    console.log("Multi Reward--", promotionData?.objectID, "reward_type--", rewardType);
                    await addPromotionData("Multi Reward", priceData, offerType = 7);
                  }
                }
              }
            }
          } else if (activePromotionLength == 2) {
            let priceData: any = {};
            let res: any;
            const hasRewardType7 = activePromotions?.find((item: any) => (item?.promotionReward.find((pr: any) => pr?.rewardType == '7')));
            const noRewardType7 = activePromotions?.find((item: any) => (item?.promotionReward.find((pr: any) => (pr?.rewardType == '1' || pr?.rewardType == '2' || pr?.rewardType == '4'))));
            if (hasRewardType7) {
              if (noRewardType7) {
                conditionType = noRewardType7?.promotionCondition?.[0]?.conditionType;
                promotionValue = noRewardType7?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
                rewardTrigger = noRewardType7?.promotionReward?.[0]?.rewardTrigger;

                promoData.conditionType = conditionType
                promoData.promotionValue = promotionValue
                promoData.rewardTrigger = rewardTrigger;
                const hasNoMinCondition = ((promoData.conditionType == undefined || promoData.conditionType == null || promoData.conditionType == "") &&
                  (rewardTrigger == null || promoData.rewardTrigger == 1 || promoData.rewardTrigger == "")) ||
                  (promoData.conditionType == 1 && promoData.promotionValue == 1 && (promoData.rewardTrigger == null || promoData.rewardTrigger == 1 || rewardTrigger == ""))
                if (hasNoMinCondition) {
                  conditionType = hasRewardType7?.promotionCondition?.[0]?.conditionType;
                  promotionValue = hasRewardType7?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
                  rewardTrigger = hasRewardType7?.promotionReward?.[0]?.rewardTrigger;
                  promoData.conditionType = conditionType
                  promoData.promotionValue = promotionValue
                  promoData.rewardTrigger = rewardTrigger;
                  const hasNoMinCondition = ((promoData.conditionType == undefined || promoData.conditionType == null || promoData.conditionType == "") &&
                    (rewardTrigger == null || promoData.rewardTrigger == 1 || promoData.rewardTrigger == "")) ||
                    (promoData.conditionType == 1 && promoData.promotionValue == 1 && (promoData.rewardTrigger == null || promoData.rewardTrigger == 1 || rewardTrigger == ""))
                  if (hasNoMinCondition) {
                    let res;
                    if (noRewardType7?.promotionReward?.[0]?.membershipLevelText?.includes("N") || noRewardType7?.promotionReward?.[0]?.membershipLevelText == '') {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText ?? 'NNNNNNNN';
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source;
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      newMemberType = 'N'
                      res = priceCalculation();
                      priceData.salePrice = res?.salePrice;
                      // priceData.newMemberPrice = (res?.memberPrice?.toFixed(2));
                    } else {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText;
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      newMemberType = 'Y'
                      res = priceCalculation();
                      priceData.newMemberPrice = (res?.memberPrice)?.toFixed(2);
                    };
                    memberType = 'YYYYYYYYYYYYYYYY'
                    promoData.memberType = memberType
                    priceData.memberPrice = hasRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                    memberPrice = priceData.memberPrice
                    promoData.memberPrice = memberPrice

                    console.log('multi promo type 1', promotionData?.objectID, "reward_type", rewardType)
                    addPromotionData('multi promo type 1', priceData, offerType = 9)
                  } else {
                    let res;
                    if (noRewardType7?.promotionReward?.[0]?.membershipLevelText?.includes("N") || noRewardType7?.promotionReward?.[0]?.membershipLevelText == '') {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText == '' ? 'NNNNNNNNNNNNNNNN' : noRewardType7?.promotionReward?.[0]?.membershipLevelText;
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source;
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      newMemberType = 'N'
                      res = priceCalculation();
                      priceData.salePrice = res?.salePrice;
                      //priceData.newMemberPrice = (res?.memberPrice?.toFixed(2));
                    } else {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText;
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      //newMemberType = 'Y'
                      res = priceCalculation();
                      //priceData.newMemberPrice = (res?.memberPrice)?.toFixed(2);
                    };
                    //memberType = 'YYYYYYYYYYYYYYYY'
                    //promoData.memberType = memberType
                    priceData.memberPrice = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                    const conditionType = hasRewardType7?.promotionCondition?.[0]?.conditionType ?? 1;
                    const conditionValue = hasRewardType7?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
                    const source = hasRewardType7?.source;
                    priceData.newMemberPrice = parseInt(hasRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1);
                    memberPrice = priceData.memberPrice
                    promoData.memberPrice = memberPrice
                    promoData.promotionSource = source
                    //priceData.newMemberPrice= priceData.newMemberPrice
                    promotionDescription = promoDescMultiPromo(breakpointFlag, priceData.newMemberPrice, conditionType, conditionValue);
                    console.log('multi promo type 2', promotionData?.objectID, "reward_type", rewardType)
                    addPromotionData('multi promo type 2', priceData, offerType = 10, promotionDescription)
                  }
                } else {
                  console.log("no promotions ", promoData.objectID);

                }
              }

            } else {
              // active promotion more than 1 -- multi promotion (2)
              const descRegex =/(?<![a-zA-Z])MP(?![a-zA-Z])/;
              const VKAO_Promotion = activePromotions?.find((item: any) => item?.source == FLYER_PROMOTIONS_SOURCE);
              const regexFilterPromo = activePromotions.find((item: any) => descRegex?.test(item.promotionDescription));
              let showVKAO = false;
              if (regexFilterPromo) {
                const firstPromotion = activePromotions[0]?.promotionReward;
                const secondPromotion = activePromotions[1]?.promotionReward;
                const firstCondition = activePromotions[0]?.promotionCondition;
                const secondCondition = activePromotions[1]?.promotionCondition;
                const rewardType1 = regexFilterPromo?.promotionReward?.[0]?.rewardType;
                const rewardType2 = secondPromotion?.[0]?.rewardType;
                if (firstPromotion?.length == 1 && secondPromotion?.length == 1 && firstCondition?.length == 1 && secondCondition?.length == 1) {
                  if (
                    (
                      // JSON.stringify(firstPromotion?.[0]?.items) ==
                      // JSON.stringify(secondPromotion?.[0]?.items) && (rewardType1 == rewardType2) &&
                      (firstPromotion?.[0]?.membershipLevelText?.includes("N") || firstPromotion?.[0]?.membershipLevelText == '') &&
                      secondPromotion?.[0]?.membershipLevelText?.includes("Y")) ||
                    (firstPromotion?.[0]?.membershipLevelText?.includes("Y") &&
                      (secondPromotion?.[0]?.membershipLevelText?.includes("N") || secondPromotion?.[0]?.membershipLevelText == ''))
                  ) {
                    if (hasNoMinCondition) {
                      showVKAO = true;
                      activePromotions?.forEach((elem: any) => {
                        if (elem?.promotionReward?.[0]?.membershipLevelText.includes("N") || elem?.promotionReward?.[0]?.membershipLevelText == '') {
                          rewardType = elem?.promotionReward?.[0]?.rewardType;
                          memberType = elem?.promotionReward?.[0]?.membershipLevelText;
                          rewardValue = elem?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                          promotionSource = elem?.source;
                          promoData.rewardType = rewardType;
                          // promoData.memberType = memberType;
                          promoData.rewardValue = rewardValue;
                          promoData.promotionSource = promotionSource;
                          res = priceCalculation();
                          priceData.salePrice = res?.salePrice;
                        } else {
                          rewardType = elem?.promotionReward?.[0]?.rewardType;
                          memberType = elem?.promotionReward?.[0]?.membershipLevelText;
                          rewardValue = elem?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                          promoData.rewardType = rewardType;
                          promoData.memberType = memberType;
                          //promoData.rewardValue= rewardValue;
                          res = priceCalculation();
                          priceData.memberPrice = res?.memberPrice;
                        }
                      });
                      // for multi promo discount on sale price for member price
                      const memberPromo = activePromotions?.find((promo: any) => promo?.promotionReward?.[0]?.membershipLevelText?.includes("Y"));
                      const newRewardValue = parseFloat(memberPromo?.promotionReward?.[0]?.value1Value20?.[0]?.value_1);
                      const salePrice = parseFloat(priceData.salePrice);

                      // Only apply logic if both reward types match
                      //   if (rewardType1 === rewardType2) {
                      let newMemberPrice = salePrice;

                      switch (rewardType1) {
                        case 4:
                        case 5:
                          newMemberPrice = newRewardValue / 100;
                          break;
                        case 1: // Fixed discount
                          newMemberPrice = salePrice - newRewardValue / 100;
                          break;

                        case 2: // Percentage discount
                          newMemberPrice =
                            salePrice - (salePrice * newRewardValue) / 100;
                          break;

                        case 3: // Weight-based discount
                          const weight = parseFloat(promotionData?.weight ?? "0");
                          newMemberPrice =
                            salePrice - (newRewardValue / 100) * weight;
                          break;

                        default:
                          break;
                      }

                      priceData.memberPrice = newMemberPrice;
                      console.log("No Min Condition with Multi Promo--", promotionData?.objectID, "reward_type", rewardType, "newMemberPrice", newMemberPrice);
                      addPromotionData("No Min Condition with Multi Promo", priceData, offerType = 6);
                    }

                    //  }
                  }
                }
              }
              if (showVKAO == false && VKAO_Promotion) {
                memberType = VKAO_Promotion?.promotionReward?.[0]?.membershipLevelText;
                rewardType = VKAO_Promotion?.promotionReward?.[0]?.rewardType;
                rewardValue = VKAO_Promotion?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                promotionSource = VKAO_Promotion?.source
                promoData.memberType = memberType
                promoData.rewardType = rewardType
                promoData.rewardValue = rewardValue
                promoData.promotionSource = promotionSource
                let priceData = priceCalculation();
                console.log('Multi promo only VKAO', promotionData?.objectID, "reward_type", rewardType)
                addPromotionData("Multi promo only VKAO", priceData, offerType = 11)
              }
            }
          } else if (activePromotionLength == 3) {
            const filteredPromo = activePromotions.find((item: any) => item.source == FLYER_PROMOTIONS_SOURCE);
            if (filteredPromo) {
              console.log("filteredPromo", filteredPromo)
              conditionType = filteredPromo?.promotionCondition?.[0]?.conditionType;
              promotionValue = filteredPromo?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
              rewardValue = filteredPromo?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
              rewardTrigger = filteredPromo?.promotionReward?.[0]?.rewardTrigger;
              promotionSource = filteredPromo?.source;
              rewardType = filteredPromo?.promotionReward?.[0]?.rewardType;
              memberType = filteredPromo?.promotionReward?.[0]?.membershipLevelText == ''? 'NNNNNNNNNNNNNNNN' : filteredPromo?.promotionReward?.[0]?.membershipLevelText
              promoData.conditionType = conditionType;
              promoData.promotionValue = promotionValue;
              promoData.rewardTrigger = rewardTrigger;
              promoData.promotionSource = promotionSource;
              promoData.rewardType = rewardType;
              promoData.rewardValue = rewardValue;
              promoData.memberType = memberType ?? 'NNNNNNNNNNNNNNNN'
              if (hasNoMinCondition) {
                //const priceData = priceCalculation(filteredPromo);
                const priceData = priceCalculation();
                console.log('3 Promotions', promotionData?.objectID, "reward_type", rewardType, priceData)
                addPromotionData('3 Promotions', priceData, offerType = 8)
              }
            }
          }
        }
      }
    }

    console.log(finalData, "finalData");
    return await finalData;
  } catch (error) {
    console.log(error);
  }
};
